export default "__VITE_ASSET__C2_C8$uG__"